<template>
	<div
		class="cart-items-groups my-3">
		<cart-group
			v-for="group in groups"
			:key="group.originId"
			:group="group"
			:products="products"
			:subdistricts="subdistricts"
			:shipping-costs="shippingCosts"
			:destination-id="destinationId"
			@change="onChange"
			@remove="remove"
			@change-shipping="changeShipping"
			@remove-shipping="removeShipping">
		</cart-group>
	</div>
</template>

<script>
import CartGroup from '@/components/CartGroup.vue';
import { getAxiosErrorMessage, duplicateVar } from '@/lib/helper';
import shipping from '@/api/shipping';

export default {
	name: 'CartGroups',
	props: {
		value: {
			type: Array,
			default: () => [],
		},
		products: {
			type: Array,
			default: () => [],
		},
		shippingCosts: {
			type: Array,
			default: () => [],
		},
		destinationId: {
			type: Number,
		},
	},
	components: {
		CartGroup,
	},
	data() {
		return {
			subdistricts: [],
		};
	},
	methods: {
		remove(cartItem) {
			this.$emit('remove', cartItem);
		},
		removeShipping(originId) {
			this.$emit('remove-shipping', originId);
		},
		getSubdistricts() {
			const subdistrictIds = JSON.stringify(this.originIds);
			const params = {
				page: 1,
				subdistrict_ids: subdistrictIds,
				get_complete_data: true,
			};
			const callback = (response) => {
				const subdistricts = response.data;
				this.subdistricts = subdistricts;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Get Subdistricts',
					text: message,
				});
			};
			shipping.getCompleteSubdistricts(params, callback, errorCallback);
		},
		onChange(item) {
			this.$emit('change', item);
		},
		changeShipping(params) {
			const { courier, shippingPackage, originId } = params;
			const shippingCosts = duplicateVar(this.shippingCosts);
			const index = shippingCosts.findIndex(({ origin }) => origin.id === originId);
			if (index !== -1) {
				const shippingCost = duplicateVar(this.shippingCosts[index]);
				const cost = shippingPackage.cost[0].value;
				shippingCost.cost = cost;
				shippingCost.courier = courier;
				shippingCost.service = shippingPackage.service;
				shippingCosts[index] = shippingCost;
				this.$emit('change-shipping', shippingCosts);
			}
		},
	},
	computed: {
		groups() {
			const cartItems = this.value;
			const grouped = [];
			cartItems.forEach((cartItem) => {
				const cartOrigin = cartItem.origin.id;
				const index = grouped.findIndex(({ originId }) => originId === cartOrigin);
				if (index === -1) {
					const group = {
						originId: cartOrigin,
						items: [cartItem],
					};
					grouped.push(group);
				} else {
					grouped[index].items.push(cartItem);
				}
			});
			return grouped;
		},
		originIds() {
			return this.groups.map(({ originId }) => originId);
		},
	},
	created() {
		this.getSubdistricts();
	},
};
</script>

<style>

</style>
